import {createAsyncThunk} from "@reduxjs/toolkit";
import $http from "@/app/_api";
import {ShopItem} from "@/app/_api/types/store";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {PaySelectionDialogFC} from "@/app/_dialogs/PaySelectionDialog/PaySelectionDialogFC";
import {hideForceLoading, showForceLoading} from "@/app/_dialogs/LoadingForceDialog/LoadingForceDialogFC";

// 获取商品配置
export const getPaymentItemsAsync = createAsyncThunk(
    'store/fetchPaymentItemsAsync',
    async () => {
        const responseData = await $http.Store.getPaymentItems();
        if (responseData?.length > 0){

        }
        return responseData;
    }
)

// 获取XTG交易配置
export const openPaymentAsync = createAsyncThunk(
    'store/fetchXTGConfig',
    async (params: ShopItem & {userId: number}) => {
        try {
            const reqParams = {
                itemsId: params.id,
                itemsType: params.itemsType,
                productId: params.productId,
                userId: params.userId,
                payAmount: params.money,
                extendParam: {
                    // uniwebview: 0,
                    unity_webgl: 1,//新字段 能自动关闭支付窗口
                    theme: "sc_random_bonus",
                    language: "en-US",
                    gold_coin: params.gc,
                    bonus_money: params.sc
                }
            }
            const responseData = await $http.Store.getXtgConfig(reqParams);
            if (responseData?.ks){
                SDialogManagerFC.openDialog(PaySelectionDialogFC, {
                    fcKey: SDialogManagerFC.getFCKey(PaySelectionDialogFC),
                    data: responseData,
                    shopItem: params,
                });
            }
            hideForceLoading()
            return responseData;
        } catch (e) {
            hideForceLoading()
            console.log(e);
        }
    }
)